import { SeriesAvailability } from '~/common/types/series-availability';
import { SeriesOverview } from '~/common/types/series-overview';

/**
 * シリーズがnoindex（検索エンジンにインデック
  スされない）であるかを判定する関数で、公開範囲が限定さ
  れているか、センシティブなストーリーを含む場合に true
  を返します
 * @param series
 * @returns
 */
export const isNoIndexSeries = (series: SeriesOverview) =>
  series.availability !== SeriesAvailability.PUBLIC ||
  series.hasSensitiveStories;
